import type { ICreateDownloadReport } from 'core/model/interfaces/downloads-uploads';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../downloads.constants';
import type { IDownloadsState } from '../downloads.types';

export const createDownloadReport = createAppAsyncThunk<unknown, ICreateDownloadReport>(
  `${SLICE_NAMESPACE}/createDownloadReport`,
  async (params: ICreateDownloadReport) => {
    try {
      const response = await apiService.downloads.createDownloadReport(params);

      notificationService.global.success('Se ha iniciado la descarga con éxito.');

      return response;
    } catch (error) {
      notificationService.drawer.error('Ocurrió un error en la descarga. Por favor, inténtalo nuevamente.');

      throw error;
    }
  },
);

export const createDownloadReportReducer: TSliceExtraReducer<IDownloadsState> = builder =>
  builder
    .addCase(createDownloadReport.pending, state => {
      state.form.loading = true;
      state.form.success = false;
    })
    .addCase(createDownloadReport.rejected, state => {
      state.form.loading = false;
      state.form.success = false;
    })
    .addCase(createDownloadReport.fulfilled, state => {
      state.form.loading = false;
      state.form.success = true;
    });
